import React from "react";
import { RAG, scoreRag, scoreBand } from "@/lib/format";

export function ScoreGauge({ score, size = 180, stroke = 14 }) {
  const rag = scoreRag(score);
  const color = RAG[rag].solid;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score));
  // 270-degree arc
  const arc = 0.75;
  const dash = c * arc;
  const offset = dash - (pct / 100) * dash;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: "rotate(135deg)" }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#E4E8EF"
          strokeWidth={stroke}
          strokeDasharray={`${dash} ${c}`}
          strokeLinecap="round"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={`${dash} ${c}`}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-4xl font-extrabold text-[#0B1729]">
          {score == null ? "—" : score}
        </span>
        <span className="text-xs font-medium text-[#1E2D44]/50">out of 100</span>
        <span className={`mt-1.5 text-xs font-semibold ${RAG[rag].text}`}>{scoreBand(score)}</span>
      </div>
    </div>
  );
}
